import { createStore } from "redux";
import reducers from "reducers";
import { loadState } from "utils/localstorage";
const store = createStore(
  reducers,
  loadState(),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
export default store;
